import request from '@/utils/request'

export function listGoods(query) {
  return request({
    url: '/wx/goods/list',
    method: 'get',
    params: query
  })
}

export function deleteGoods(data) {
  return request({
    url: '/goods/delete',
    method: 'post',
    data
  })
}

export function publishGoods(data) {
  return request({
    url: '/goods/create',
    method: 'post',
    data
  })
}

export function detailGoods(params) {
  return request({
    url: '/wx/goods/detail',
    method: 'get',
    params: params
  })
}
//大家都在看
export function related(id) {
  return request({
    url: '/wx/goods/related',
    method: 'get',
    params: { id }
  })
}

export function editGoods(data) {
  return request({
    url: '/goods/update',
    method: 'post',
    data
  })
}

export function listCatAndBrand() {
  return request({
    url: '/goods/catAndBrand',
    method: 'get'
  })
}
export function updateSaleStatus(data) {
  return request({
    url: '/goods/updateSaleStatus',
    method: 'post',
    data
  })
}

export function getMoreGoods(data) {
  return request({
    url: '/wx/goods/getSonsGoods',
    method: 'post',
    data: data
  })
}
// // 获取评论分页数据
// export function getComentList(valueId, page, size) {
//   return request({
//     url: '/wx/goods/getComentList?valueId=' + valueId + '&page=' + page + '&size=' + size,
//     method: 'get',
//   });
// }
// 获取评论分页数据
export function getComentList(params) {
  return request({
    url: '/wx/goods/getComentList',
    method: 'get',
    params: params,
  });
}
// 获取商品对比数据
export function getGoodCompareDetail(params) {
  return request({
    url: '/wx/goods/getCompareGoodsDetail',
    method: 'post',
    data: params,
  });
}


// 获取商品对比数据
export function getGoodCompareDetailWeb(params) {
  return request({
    url: '/wx/goods/getCompareGoodsDetailWeb',
    method: 'post',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/goods/goods.js